import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import moment from "moment";
import $ from "jquery";
import { sweetAlert } from "../../Common/Utills/Utills";
import UpdateMaterialIncoming from "./UpdateMaterialIncoming";
import Pagination from "../../Common/Pagination/Pagination";
import IncomingDetails from "./IncomingDetails";
import AddMaterialIncoming from "./AddMaterialIncoming";
import _ from "lodash";
import { minDate } from "../../Constants/Constants";
const MaterialIncoming = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [materialData, setMaterialData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [incomingDetails, setIncomingDetails] = useState([]);
  const [selectedMaterialId, setSelectedMaterialId] = useState("");
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);

  const [rowAddData, setRowAddData] = useState({
    material_name: "",
  });
  const formRef = useRef(null);
  // console.log("rowData", rowAddData)

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };

  const [filterCriteria, setfilterCriteria] = useState({
    company_id: selectedCompanyId,
    material_name_id: selectedMaterialId,
    date: "",
    start_date: "",
    end_date: "",
  });

  const handleFilterChange = (name, value) => {
    setfilterCriteria(() => {
      return {
        ...filterCriteria,
        [name]: value,
      };
    });
  };
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setselectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const nonEmptyFilterCriteria = Object.fromEntries(
    Object.entries(filterCriteria).filter(
      ([key, value]) => value !== null && value !== undefined && value !== ""
    )
  );
  const options = {
    whereFilters: nonEmptyFilterCriteria,
    skip: currentPage,
    take: pageSize,
  };
  const getData = async () => {
    let BASE_URL =
      SERVER_URL +
      `/api/mat-incoming/all-material-incoming/${user_id}?company_id=${
        filterCriteria.company_id
      }&material_name_id=${filterCriteria.material_name_id}&start_date=${
        filterCriteria.start_date
      }&end_date=${filterCriteria.end_date}&skip=${
        (currentPage - 1) * pageSize
      }&take=${pageSize}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log("result", result.data);
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(
        result.data.map((item, index) => {
          return {
            ...item,
            date: moment.utc(item.date).format("YYYY-MM-DD").toString(),
          };
        })
      );

      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.hideOverlay();
      }
    } else {
      setRowData([]);
    }
  };

  let check = true;
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);
  useEffect(() => {
    if (check) {
      if (loadingOverlayVisible) {
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.showLoadingOverlay();
        }
      }
      setLoadingOverlayVisible(true);
      const fecthDebounced = _.debounce(getData, 500);
      fecthDebounced();
      return () => {
        fecthDebounced.cancel();
      };
    }
    check = false;
  }, [currentPage, pageSize, filterCriteria]);
  useEffect(() => {
    setCurrentPage(1);
  }, [pageSize, filterCriteria]);

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
  }, []);

  const deleteRow = async (id) => {
    const message = "Do you want to delete this material incoming!";
    const result = await sweetAlert(message);
    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL =
      SERVER_URL + `/api/mat-incoming/material-incoming/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
        };
      });
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const addDataToModal = async (rowData) => {
    setselectedRowsData(rowData);
  };

  const getMaterialData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/raw-mat-name/all-material-names/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setMaterialData(result.data);
    } else {
      setMaterialData([]);
    }
  };
  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
    // console.log(result.data)
  };

  useEffect(() => {
    getCompany();
    getMaterialData();
  }, []);

  const handleCompanyChange = (e) => {
    const companyId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectedCompanyId(companyId);

    // Update filterCriteria with the selected company's ID
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));
  };

  const handleMaterialChange = (e) => {
    const materialId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectedMaterialId(materialId);

    // Update filterCriteria with the selected company's ID
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      material_name_id: materialId,
    }));
  };

  const CustomCellRenderer = (props) => {
    const { value } = props;
    // console.log("props", value)

    return <IncomingDetails rowData={value} />;
  };
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => {
        const currentPageContext = params.context.currentPage;
        const pageSizeContext = params.context.pageSize;
        return (
          (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
        );
      },
      minWidth: 100,
      // headerCheckboxSelection: true,
      // checkboxSelection: true,
      // cellStyle: { display: "flex", alignItems: "center" },
    },
    // {
    //   headerName: "Party Name",
    //   field: "partyName.party_name",
    //   editable: true,
    //   minWidth: 205,
    // },
    {
      headerName: "Company",
      field: "company.company_name",
      valueFormatter: (params) => {
        const location = params.data.company.location;
        const type = params.data.company.type;
        return `${params.value}, ${location}`;
      },
      editable: false,
      minWidth: 300,
      cellStyle: { display: "inline-flex" },
    },
    {
      headerName: "Material Name",
      field: "materialName.material_name",
      editable: false,
      minWidth: 205,
      cellStyle: { display: "flex", alignItems: "center" },
    },

    {
      headerName: "Incoming Details",
      field: "incoming_details",
      editable: false,
      cellRenderer: CustomCellRenderer, // Used for rendering in the grid
      autoHeight: true,
      minWidth: 300,
      cellStyle: { display: "flex", alignItems: "center" },
      valueFormatter: (params) => {
        // Format the data for CSV export
        if (Array.isArray(params.value)) {
          // Assuming incoming_details is an array of objects
          return params.value
            .map((detail) => {
              // Adjust formatting based on the structure of detail
              return `${detail.party_name || "N/A"}: ${detail.incoming || "N/A"}`;
            })
            .join("; ");
        } else if (params.value && typeof params.value === "object") {
          // If it's a single object, handle it
          return `${params.value.party_name || "N/A"}: ${params.value.incoming || "N/A"}`;
        }
        return "N/A"; // Default for empty or invalid data
      },
    },
    
    // {
    //   headerName: 'Incoming Details',
    //   minWidth: 300,
    //   editable: false,
    //   children: [
    //     { headerName: 'Party Name', field: 'party_name' },
    //     { headerName: 'Incoming', field: 'incoming' }
    //   ]
    // },
    // {
    //   headerName: "Incoming",
    //   field: "incoming_details",
    //   editable: false,
    //   valueFormatter: (params) => {
    //     // Check if incoming_details is an array
    //     if (Array.isArray(params.value)) {
    //       // Map over each item in the incoming_details array
    //       const formattedDetails = params.value.map((detail) => {
    //         // Assuming each detail object has a property 'propertyName' you want to display
    //         console.log(detail)
    //         return `${detail.incoming}`;
    //       });
    //       // Join the formatted details into a single string
    //       return formattedDetails.join(', ');
    //     } else {
    //       // If incoming_details is not an array, return as is
    //       return JSON.stringify(params.value);
    //     }
    //   },
    //   minWidth: 205,
    // },

    // {
    //   headerName: "Incoming",
    //   field: "incoming",
    //   editable: false,
    //   minWidth: 205,
    // },
    {
      headerName: "Date",
      field: "date",
      editable: false,
      minWidth: 205,
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      headerName: "Actions",
      suppressCsvExport: true,
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => deleteRow(params.data.id)}
          >
            <i className="mdi mdi-delete" />
          </button>{" "}
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => addDataToModal(params.data)}
            data-toggle="modal"
            data-target="#editModal"
          >
            <i className="mdi mdi-note-edit-outline" />
          </button>
        </>
      ),
      minWidth: 205,
      cellStyle: { display: "flex", alignItems: "center" },
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    flex: 1,
    editable: true,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );

  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
    setfilterCriteria({
      company_id: "",
      material_name_id: "",
      date: "",
      start_date: "",
      end_date: "",
    });
    setSelectedCompanyId("");
    setSelectedMaterialId("");
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Material Incoming Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add Material
              </button>
            </div>

            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>
          <div className="search mb-3">
            <div className="row">
              {/* <div class="col-md-3">
                  <div class="form-group">
                  <Creatable
                              isClearable
                              onChange={handlePartyNameChange}
                              onCreateOption={handleCreate}
                              options={partyNameOptions}
                              value={selectedPartyName}
                              // menuIsOpen={true}
                              menuPosition="fixed"
                            />
                  </div>
                </div> */}
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="company">Company Name</label>
                  <select
                    className="form-control form-control-lg"
                    onChange={handleCompanyChange}
                    value={selectedCompanyId}
                    id="company"
                  >
                    <option value="">Select Company (All)</option>
                    {company &&
                      company?.length > 0 &&
                      company?.map((item, id) => {
                        return (
                          <option
                            value={item.id}
                            key={id}
                          >{`${item.company_name}, ${item.location}`}</option>
                        );
                      })}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="material_name_id">Material Name</label>
                  <select
                    className="form-control form-control-lg"
                    onChange={handleMaterialChange}
                    value={selectedMaterialId}
                    id="material_name_id"
                  >
                    <option value="">Select Material (All)</option>
                    {materialData?.map((item, id) => {
                      return (
                        <option
                          value={item.id}
                          key={id}
                        >{`${item.material_name}`}</option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="start_date">From</label>
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    placeholder="Search from Date"
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      handleFilterChange("start_date", e.target.value)
                    }
                    value={filterCriteria.start_date}
                    id="start_date"
                    min={minDate}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="end_date">To</label>
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    placeholder="Search to Date"
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      handleFilterChange("end_date", e.target.value)
                    }
                    name="end_date"
                    value={filterCriteria.end_date}
                    min={minDate}
                    id="end_date"
                  />{" "}
                </div>
              </div>
              {/* <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Search by party name"
                    onChange={(e) =>
                      handleFilterChange("party_name", e.target.value)
                    }
                  />
                </div> */}
              {/* <div className="col-md-3">
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    placeholder="Search by Date"
                    onChange={(e) => handleFilterChange("date", e.target.value)}
                  />
                </div> */}
            </div>
          </div>
          <div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                context={{ currentPage, pageSize }}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>
          <AddMaterialIncoming
            handleChange={handleChange}
            //   setimgfile={setimgfile}
            getData={getData}
            formRef={formRef}
          />
          <UpdateMaterialIncoming
            selectedRowsData={selectedRowsData}
            updateHandleChange={updateHandleChange}
            getData={getData}
            setselectedRowsData={setselectedRowsData}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default MaterialIncoming;
